jQuery(document).on('click','.js-link', function(e) {
    link = jQuery(this).data('link');
    window.open('/specialite/' + link,'_self');
}); 

jQuery(document).on('click','.js-btn--appointment', function(e) {
    window.open('/demande-de-consultation/','_self');
}); 

